import React, { Component } from 'react';
import { DropdownV2, TextArea, Tooltip, Button, Notification } from 'carbon-components-react';
import { toast } from 'react-toastify';
import { Card } from '../../../../components';
import {
  getByDmService,
  getDmService,
  updateDmService,
  insertDmService
} from '../../../../services/Api';
import EditCategory from '../../CategoryModels/Edit/index';
import ModalDm from '../../../../components/Modal/ModalDm';

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItemType: { id: 0, label: 'Selecionar Tipo' },
      selectedItemCategory: null,
      descriptionTextarea: '',
      categoryMessage: [],
      categorySac: [],
      disabledButton: true,
      OpenCategory: false,
      nrCaracteresMsg: 0
    };
  }

  componentWillMount() {
    const { idEdit } = this.props;
    if (idEdit) {
      this.getData(idEdit);
    }
    this.getCategory();
    this.enableButton();
    this.setTypeModel();
  }

  setTypeModel() {

    const sac = window.location.href.match(/sac/);
    const IdObj = sac ? 2 : 1;
    const objLabel = sac ? 'SAC' : 'Mensagem';
    const obj = { id: IdObj, label: objLabel };
    this.setState({
      selectedItemType: obj
    });
  }

  managerVisited = () => {
    const { match: propMatch } = this.props;
    const urlVisited = propMatch.url;
    const sac = urlVisited.match(/sac/);
    if (sac) {
      this.setState({
        selectedItemType: {id: 2, label: "sac"}
      });
    } else {
      this.setState({
        selectedItemType: {id: 1, label: "mensagem"}
      });
    }
  };

  save = () => {
    const {
      disabledButton,
      selectedItemType,
      selectedItemCategory,
      descriptionTextarea
    } = this.state;
    if (!disabledButton) {
      const idModCategory = selectedItemCategory.id;
      const tipoMessage = selectedItemType.id;
      const descricao = descriptionTextarea;
      const formData = {
        ModeloCategoria: { id: idModCategory, tipo: tipoMessage },
        Descricao: descricao
      };

      insertDmService('/Modelo', formData);
      toast.success('Modelo salvo com sucesso.');
      this.goRoute();
    } else {
      toast.error(
        'Verifique se todos os campos necessários estão preenchidos.'
      );
    }
  };

  edit = () => {
    const {
      disabledButton,
      descriptionTextarea,
      selectedItemCategory
    } = this.state;

    if (!disabledButton) {
      const { idEdit } = this.props;
      const idModCategory = selectedItemCategory.id;
      const descricao = descriptionTextarea;
      const formData = {
        Id: idEdit,
        ModeloCategoria: { id: idModCategory },
        Descricao: descricao
      };
      updateDmService('/Modelo', idEdit, formData);
      toast.success('Alterações realizadas com sucesso.');
      this.goRoute();
    } else {
      toast.error(
        'Verifique se todos os campos necessários estão preenchidos.'
      );
    }
  };

  goRoute = () => {
    const { push } = this.props;
    const { selectedItemType } = this.state;
    const label = selectedItemType.label.toLowerCase();
    push(`/admin/modelos-mensagem/lista/${label}`);
  };

  getData = idEdit => {
    getByDmService('/Modelo/Get', idEdit)
      .then(res => {
        this.setState({
          descriptionTextarea: res.descricao,
          nrCaracteresMsg: res.descricao.length,
          selectedItemType:
            res.modeloCategoria.tipo === 1
              ? { id: 1, label: 'Mensagem' }
              : { id: 2, label: 'SAC' },
          selectedItemCategory: {
            id: res.modeloCategoria.id,
            label: res.modeloCategoria.nome
          }
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getCategory = async () => {
    try {
      const data = await getDmService('ModeloCategoria/Get');
      await this.insertArrTypes(data);
    } catch (error) {
      console.log(error)
    }   
  }

  insertArrTypes(data) {
    const messageList = [];
    const sacList = [];

    data.forEach(item => {
      if(item.tipo === 1){
        messageList.push({id: item.id, label: item.nome})       
      }

     if(item.tipo === 2){
        sacList.push({id: item.id, label: item.nome})    
      }
    });

    this.setState({
      categoryMessage: messageList,
      categorySac: sacList
    });
   
  }

  onChange = (item, change) => {
    if (change === 'tipo') {
      this.setState({ selectedItemType: item.selectedItem });
    } else {
      this.setState({ selectedItemCategory: item.selectedItem }, () => {
        this.enableButton();
      });
    }
  };

  onChangeText = value => {
    this.setState({ descriptionTextarea: value }, () => {
      this.enableButton();
    });

    this.countCaracteresMessage();
  };

  countCaracteresMessage = () => {
    const {descriptionTextarea} = this.state;
    const foundTagOn = descriptionTextarea.indexOf('<NOME_CRM>') > -1;
    const foundTagTwo = descriptionTextarea.indexOf('<NOME_CLIENTE>') > -1;
 
    let nrCaracters = descriptionTextarea.length;
    const tagCrm = [];
    const tagClient = [];
    
      if(foundTagOn){
        tagCrm.push("<NOME_CRM>");
      }
      if(foundTagTwo){
        tagClient.push("<NOME_CLIENTE>");
      }
   
    let plus = 0;

    if(tagClient.length){
      plus += ((tagClient.length * 1));
    }
    if(tagCrm.length){
      plus += ((tagCrm.length * 10));     
    }

    nrCaracters += plus;      
    this.setState({nrCaracteresMsg: nrCaracters})
  }


  enableButton = () => {
    const { idEdit } = this.props;
    const { selectedItemCategory, descriptionTextarea } = this.state;

    if (
      (selectedItemCategory !== null && descriptionTextarea !== '') ||
      idEdit
    ) {
      this.setState({
        disabledButton: false
      });
    } else {
      this.setState({
        disabledButton: true
      });
    }
  };

  addTag = (tag) => {

    this.setState(prevState => ({
      descriptionTextarea: `${prevState.descriptionTextarea}${tag}`
    }), () => {
      this.countCaracteresMessage()
    });
  };
  

  hiddenModal = () => {
    this.setState({ OpenCategory: false }, () => {
    
      this.getCategory();
    });
  };

  openModal = () => {
    this.setState({ OpenCategory: true });
  };

  render() {
    const { idEdit } = this.props;
    const {
      selectedItemType,
      selectedItemCategory,
      descriptionTextarea,
      categoryMessage,
      categorySac,
      OpenCategory,
      nrCaracteresMsg
    } = this.state;

    return (
      <div>
        <Card className="center-box">
          <div className="mg-left-20 mg-top-20">
            <div className="bx--row ">
              <div className="bx--col-xs-11 bx--col-md-6 v-sm-margin">
                <label htmlFor="tipo">Tipo</label> 
                {' '}
                <br />
                <DropdownV2
                  label="Selecionar Tipo"
                  id="tipo"
                  items={[
                    { id: 0, label: 'Selecionar Tipo' },
                    { id: 1, label: 'Mensagem' },
                    { id: 2, label: 'SAC' }
                  ]}
                  selectedItem={selectedItemType}
                  onChange={e => this.onChange(e, 'tipo')}
                />
              </div>
            </div>
            <div className="bx--row ">
              <div className="bx--col-xs-11 bx--col-md-6 v-sm-margin">
                <label htmlFor="categoria">Categoria</label> 
                {' '}
                <br />
                {selectedItemType.id === 2 ? (
                  <DropdownV2
                    label="Selecionar Categoria"
                    id="categoria"
                    items={categorySac}
                    selectedItem={selectedItemCategory}
                    onChange={e => this.onChange(e, 'category')}
                  />
                ) :
                (
                  <DropdownV2
                    label="Selecionar Categoria"
                    id="categoria"
                    items={categoryMessage}
                    selectedItem={selectedItemCategory}
                    onChange={e => this.onChange(e, 'category')}
                  />                  
                )

                }
                
              </div>
              {nrCaracteresMsg > 135 &&
                (
                  <div className="bx--col-xs-12 bx--col-md-12 bx--col-sm-12 v-md-margin">
                    <Notification
                      kind="warning"
                      title="Atenção"
                      subtitle="Sua mensagem deve ter no máximo 135 caracteres."
                    />
                  </div>
                )
              }               
              <div className="bx--col-xs-11 bx--col-md-5 v-center-link ">
                <a
                  onClick={() => this.openModal()}
                  title="Ir para o gerênciamento de Modelos de Mensagem"
                  className="bx--link mg-top-20 pointer"
                >
                  {' '}
                  Criar Categoria
                  {' '}
                </a>
              </div>
              
              <div className="bx--col-xs-11 mg-top-20">
                <TextArea
                  labelText={`Texto para ${
                    selectedItemType.id === 1 ? 'Mensagem' : 'SAC'
                  }`}
                  value={descriptionTextarea}
                  onChange={e => this.onChangeText(e.target.value)}
                  placeholder="Digite"
                />
              </div>
              {selectedItemType.id === 1 && (
                <div className="bx--col-xs-11 v-md-margin">
                  <div className="flex--inline left-fluit">
                    <Tooltip
                      triggerText="Tags especiais"
                      direction="top"
                      clickToOpen
                    >
                      <p className="bx--tooltip__label">
                        Insira uma tag especial na sua mensagem!
                      </p>
                    </Tooltip>
                  </div>
                  <div className="tags h-md-margin flex--inline">
                    <button
                      className="button button--clear left-fluit"
                      onClick={() => this.addTag('<NOME_CRM>')}
                      type="submit"
                    >
                      <span className="bx--tag bx--tag--ibm">Nome da Loja</span>
                    </button>
                    <button
                      className="button button--clear left-fluit"
                      onClick={() => this.addTag('<NOME_CLIENTE>')}
                      type="submit"
                    >
                      <span className="bx--tag bx--tag--ibm">
                        Nome do Cliente
                      </span>
                    </button>
                    <span
                      className="font-size-13"
                      style={{ color: nrCaracteresMsg > 135 ? 'red' : '' }}
                    >
                      {nrCaracteresMsg}
                    </span>
                  </div>
                </div>
              )}

              <div className="bx--col-xs-12  v-md-margin">
                <Button 
                  onClick={idEdit ? this.edit : this.save}
                  disabled={nrCaracteresMsg > 135}
                >
                  Salvar
                </Button>

                <a
                  onClick={() => this.goRoute()}
                  className="bx--link mg-left-20 pointer"
                >
                  Cancelar
                </a>
              </div>
            </div>
          </div>
        </Card>
        <ModalDm
          openModal={this.openModal}
          heading="Criar Categoria"
          hiddenModal={this.hiddenModal}
          openMd={OpenCategory}
        >
          <EditCategory hiddenModal={this.hiddenModal} inheritModal />
        </ModalDm>
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/screens/admin/MessageModels/Edit/Edit.jsx